module.exports = __webpack_public_path__ + "assets/img/8_1691_big.937ddfdf.jpg";